import { render, staticRenderFns } from "./VYak.vue?vue&type=template&id=664f5108&"
import script from "./VYak.vue?vue&type=script&lang=js&"
export * from "./VYak.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports